import { getShortlists } from "api";
import { Error } from "utils/Response";
import { SetDecisionDetails } from "../GetDecisionDetails/action";
import { ActionTypes } from "./types";

export const GetShortlists = (decisionId) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await getShortlists(decisionId);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    dispatch(SetDecisionDetails(data));
    if (status === 200) {
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
